import React, { useState } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { NavLink as RouterNavLink, withRouter } from "react-router-dom";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
	ListItem,
	ListItemText,
	Drawer as MuiDrawer,
	List as MuiList
} from "@material-ui/core";
import { useHistory } from "react-router";

import "../vendor/perfect-scrollbar.css";
import { DashboardRoutes } from "../routes/index";
import { showGettingStartedDialog, showPrivacyPolicyDialog, showSupportDialog } from "../store/dialogs/dialogsActions";
import SettingsDialog from "./Dialogs/SettingsDialog";

const NavLink = React.forwardRef((props, ref) => (
	<RouterNavLink innerRef={ref} {...props} />
));

const Drawer = styled(MuiDrawer)`
  > div {
  	width: ${props => props.theme.widthRatio * 280}px;
    border-right: 0;
  }
`;

const Scrollbar = styled(PerfectScrollbar)`
  background-color: ${props => props.theme.sidebar.background};
`;

const List = styled(MuiList)`
  background-color: ${props => props.theme.sidebar.background};
  
  &.items-wrapper {
  	padding: 0 ${props => props.theme.widthRatio*14}px;
  }
`;

const Items = styled.div`
  padding-top: ${props => props.theme.heightRatio*props.theme.spacing(3.5)}px;
`;

const LogoWrapper = styled.div`
	padding-top: ${props => props.theme.widthRatio*19}px;
	padding-left: ${props => props.theme.widthRatio*26}px;
	padding-right: ${props => props.theme.widthRatio*40}px;
  background-color: ${props => props.theme.sidebar.header.background};
  min-height: ${props => props.theme.heightRatio*157}px;
`;

const Logo = styled.img`
  width: ${props => props.theme.widthRatio*214}px;
  height: ${props => props.theme.widthRatio*72}px;
  cursor: pointer;
`;

const Link = styled(ListItem)`
  display: flex;
  align-items: center;
  padding-left: ${props => props.theme.widthRatio*props.theme.spacing(4)}px;
  min-height: ${props => props.theme.heightRatio*64}px;
  margin-bottom: ${props => props.theme.heightRatio*props.theme.spacing(3.5)}px;
  
  &:hover {
    background-color: ${props => props.theme.sidebar.item.hoverBackground};
  }

  &.${props => props.activeClassName} {
    background-image:
    	linear-gradient(
    		to right,
    		${props => props.theme.sidebar.item.activeLinearBackgroundColor1} 2%,
    		${props => props.theme.sidebar.item.activeLinearBackgroundColor2} 2%,
    		transparent 10%,
    		transparent 10%
    	);
  }
`;

const Icon = styled.div`
	width: 20%;
	display: flex;
	justify-content: center;
	
  img {
    max-width: ${props => props.theme.widthRatio * 23}px;
  	max-height: ${props => props.theme.widthRatio * 23}px;
  }
`;

const LinkText = styled(ListItemText)`
  margin-top: 0;
  margin-bottom: 0;
  color: ${props => props.theme.sidebar.color};
  
  span {
    font: ${props => props.theme.widthRatio*21}px/${props => props.theme.heightRatio*28}px SFProRounded-Regular;
    display: block;
  }
`;

const BadgeText = styled.span`
	position: absolute;
  left: ${props => props.theme.widthRatio*170}px;
  text-transform: uppercase;
  font: ${props => props.theme.widthRatio*18}px/${props => props.theme.heightRatio*24}px SFProRounded-Bold;
  color: #FFBD59;
`;

const SidebarFooter = styled.div`
  background: ${props => props.theme.sidebar.footer.background};
`;


const Item = styled(ListItem)`
  display: flex;
  align-items: center;
 	padding-left: ${props => props.theme.widthRatio*props.theme.spacing(1)}px;
  min-height: ${props => props.theme.heightRatio*64}px;
  margin-bottom: ${props => props.theme.heightRatio*props.theme.spacing(3.5)}px;
	border-radius: 5px;
	
	&.active {
    background-color: ${props => props.theme.sidebar.item.hoverBackground};
  }
	
  &:hover {
    background-color: ${props => props.theme.sidebar.item.hoverBackground};
  }
`;

const SidebarLink = ({ name, to, icon, isNew, onClose }) => {
	return (
		<Link
			button
			dense
			component={NavLink}
			to={to}
			activeClassName="active"
			onClick={onClose ? () => onClose() : null}
		>
			<Icon><img src={`/static/img/icon/${icon}_icon.svg`} alt={`${icon}`}/></Icon>
			<LinkText>{name}</LinkText>
			{isNew && <BadgeText>New</BadgeText>}
		</Link>
	);
};

const generateRoutes = (routes, onClose) => (
	routes.map((route, index) => (
		<SidebarLink
			key={index}
			name={route.name}
			to={route.path}
			icon={route.icon}
			isNew={route.isNew}
			onClose={onClose}
		/>
	))
);

const Sidebar = (props) => {
	const history = useHistory();
	const {
		staticContext,
		onClose,
		openGettingStartedDialog,
		openSupportDialog,
		openPrivacyPolicyDialog,
		showGettingStartedDialog,
		showPrivacyPolicyDialog,
		showSupportDialog,
		...other
	} = props;
	const [showSettingsDialog, setShowSettingsDialog] = useState(false);

	return (
		<Drawer variant="permanent"{...other}>
			<LogoWrapper>
				<Logo src={`/static/img/logo/logo.svg`} alt='Logo' onClick={() => history.push('/')}/>
			</LogoWrapper>
			<Scrollbar>
				<List disablePadding>
					<Items>
						{ generateRoutes(DashboardRoutes, onClose) }
					</Items>
				</List>
			</Scrollbar>
			<SidebarFooter>
				<List className="items-wrapper">
					<Item
						button
						onClick={() => showGettingStartedDialog(true)}
						className={openGettingStartedDialog && 'active'}
					>
						<Icon><img src={`/static/img/icon/instructions.png`} alt={`instruction`}/></Icon>
						<LinkText>Getting Started</LinkText>
					</Item>
					<Item
						button
						onClick={() => showSupportDialog(true)}
						className={openSupportDialog && 'active'}
					>
						<Icon><img src={`/static/img/icon/contact_us_icon.svg`} alt={`contact-us`}/></Icon>
						<LinkText>Support</LinkText>
					</Item>
					<Item
						button
						onClick={() => showPrivacyPolicyDialog(true)}
						className={openPrivacyPolicyDialog && 'active'}
					>
						<Icon><img src={`/static/img/icon/privacy_icon.svg`} alt={`privacy-policy`}/></Icon>
						<LinkText>Privacy Policy</LinkText>
					</Item>
					<Item
						button
						onClick={() => setShowSettingsDialog(true)}
						className={showSettingsDialog && 'active'}
					>
						<Icon><img src={`/static/img/icon/settings_icon.svg`} alt={`settings`}/></Icon>
						<LinkText>Settings</LinkText>
					</Item>
				</List>
			</SidebarFooter>
			<SettingsDialog
				isShow={showSettingsDialog}
				setIsShow={setShowSettingsDialog}
			/>
		</Drawer>
	);
};

const mapStateToProps = (state) => ({
	openGettingStartedDialog: state.dialogsReducer.openGettingStartedDialog,
	openSupportDialog: state.dialogsReducer.openSupportDialog,
	openPrivacyPolicyDialog: state.dialogsReducer.openPrivacyPolicyDialog
});

const mapDispatchToProps = {
	showGettingStartedDialog, showPrivacyPolicyDialog, showSupportDialog
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));
